exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".representation-add-contact {\n  padding-bottom: 4rem;\n}\n\n.representation-add-contact>.form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.representation-add-contact .representation-add-contact__title {\n  padding-bottom: 16rem;\n}\n\n", ""]);

// exports
